import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchWrapper } from '../_helpers';

// create slice

const name = 'programari';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const programariActions = { ...slice.actions, ...extraActions };
export const programariReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        programari: {}
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/programari/list`;

    return {
        getAll: getAll()
    };    

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async () => await fetchWrapper.get(baseUrl)
        );
    }
}

function createExtraReducers() {
    return {
        ...getAll()
    };

    function getAll() {
        var { pending, fulfilled, rejected } = extraActions.getAll;
        return {
            [pending]: (state) => {
                state.programari = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.programari = action.payload;
            },
            [rejected]: (state, action) => {
                state.programari = { error: action.error };
            }
        };
    }
}
